import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';

import { ChannelSearchSelect } from './channel-search-select';
import { Separator } from '@/components/ui/separator';

interface ChannelSearchSectionProps {
  channelId: number | undefined;
  channelName: string | undefined;
  onChannelChange: (id: number | undefined, name?: string) => void;
}

export function ChannelSearchSection({
  channelId,
  channelName,
  onChannelChange,
}: ChannelSearchSectionProps) {
  return (
    <>
      <div className="flex flex-col items-start gap-1 self-stretch">
        <Typography variant="medium2">
          <FormattedMessage
            defaultMessage="Add Contract"
            description="Add contract sheet: page heading"
          />
        </Typography>
        <Typography variant="subtitle1">
          <FormattedMessage
            defaultMessage="Search and connect a job board contract to Source"
            description="Add contract sheet: subtitle under heading"
          />
        </Typography>
      </div>

      <Separator className="max-w-[500px]" />

      <div className="flex flex-col items-start gap-2 self-stretch">
        <Typography variant="body2" className="!text-fx-neutral-600">
          <FormattedMessage
            defaultMessage="Select board"
            description="Add contract sheet: label for channel search field"
          />
          <span className="text-fx-rose">*</span>
        </Typography>
        <Typography variant="small1" className="text-fx-neutral-600">
          <FormattedMessage
            defaultMessage="BYOC — Bring Your Own Contract. Connect channel where you already have a direct contract."
            description="Add contract sheet: help text under channel search label"
          />
        </Typography>
        <ChannelSearchSelect
          selectedChannelId={channelId}
          selectedChannelName={channelName}
          onChannelChange={onChannelChange}
        />
      </div>
    </>
  );
}
